'use strict';

var isIterable = require('./is-iterable');

module.exports = function (value) {
	if (!isIterable(value)) throw new TypeError(value + " is not iterable");
	return value;
};



//////////////////
// WEBPACK FOOTER
// ./~/es6-iterator/valid-iterable.js
// module id = 320
// module chunks = 0